export default __webpack_public_path__ + "locales/ko-KR/SMTPSettings.json?hash=1aa9df106886ea1aa89be9aa79fd56c1";